import * as moment from 'moment';
import { Moment } from 'moment';

// export enum WeekDaysSort {
//   'monday' = 1,
//   'tuesday' = 2,
//   'wednesday' = 3,
//   'thursday' = 4,
//   'friday' = 5,
//   'saturday' = 6,
//   'sunday' = 0
// }

// export const TranslationDates = {
//   1: 0,
//   2: 1,
//   3: 2,
//   4: 2,
//   5: 4,
//   6: 5,
//   0: 6
// };

export enum WeekDays {
  'monday' = 0,
  'tuesday' = 1,
  'wednesday' = 2,
  'thursday' = 3,
  'friday' = 4,
  'saturday' = 5,
  'sunday' = 6
}

export const formatDate = (date: Date, format: string) => {
  return moment(date).format(format);
};

export const getWeekDate = (startDate: moment.Moment, weekDay: number, format?: string): string => {
  if (!format) {
    format = 'DD.MM.YYYY';
  }

  return moment(startDate)
    .startOf('isoWeek')
    .add(weekDay, 'd')
    .format(format);
};

export enum DateTranslations {
  'monday' = 'Montag',
  'tuesday' = 'Dienstag',
  'wednesday' = 'Mittwoch',
  'thursday' = 'Donnerstag',
  'friday' = 'Freitag',
  'saturday' = 'Samstag',
  'sunday' = 'Sonntag'
}

export enum DateShortForms {
  'monday' = 'MO',
  'tuesday' = 'DI',
  'wednesday' = 'MI',
  'thursday' = 'DO',
  'friday' = 'FR',
  'saturday' = 'SA',
  'sunday' = 'SO'
}

export const DateArray = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday'
];

export interface Daterange {
  start?: Date | Moment;
  end?: Date | Moment;
  weekdays?: number[];
}



// WEBPACK FOOTER //
// ./src/utils/dateHelper.ts